@if (shouldShow) {
  <div class="pending-invoice-container">
    <div class="pending-invoice-top">
      <i class="pi pi-exclamation-triangle pending-invoice-banner__icon" aria-hidden="true"></i>
      <strong id="pendingInvoiceBannerTitle">{{ 'payment_detail_pending_invoice_banner_title' | translate }}</strong>
      <button id="closeDialogButton" type="button" class="detail-modal-close" (click)="onClose?.()"
          aria-label="Close dialog">
          <i class="pi pi-times" aria-hidden="true"></i>
      </button> 
    </div>
    <div class="pending-invoice-bottom">
      <div class="pending-invoice-text">
        <span id="pendingInvoiceBannerRequiredInvoice">{{ 'payment_detail_pending_invoice_banner_required_invoice' | translate }}</span>
        @if (shouldShowFuturePaymentsBlocked) {
        <span id="pendingInvoiceBannerFuturePaymentsBlocked">{{ 'payment_detail_pending_invoice_banner_future_payments_blocked' | translate }}</span>
        }
      </div>
      @if (billBackBillingUrl) {
      <a id="pendingInvoiceBannerButton" pButton class="p-button-lg pending-invoice-banner__button"
        [href]="billBackBillingUrl" target="_blank" rel="noopener noreferrer">
        {{ 'payment_detail_pending_invoice_banner_button' | translate }}
      </a>
      }
    </div>
  </div>
}